import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=c7d8ff0a"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"
import style0 from "./WelcomeDialog.vue?vue&type=style&index=0&id=c7d8ff0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports